import { GACSPageLoad } from '@analytics/classes/ga.error.class';
import { AnalyticsService } from '@analytics/services/analytics.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '@core/components/base/base.component';
import {
  CurrentPlan,
  ErrorType,
  isLiveChatActive,
} from '@dgx-pr-spa/shared/util';
import { BuildConfigService } from '@dgx-pr-spa/ui-components';
import { LiveChatService } from '@pages/services/live-chat.service';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
import { take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent extends BaseComponent implements OnInit {
  msg = '';
  links = this.buildConfigService.config.header.links;
  currentPlan: CurrentPlan;
  ErrorType = ErrorType;

  isLiveChatActive = isLiveChatActive();

  constructor(
    private readonly viewOffersService: ViewOffersService,
    private readonly buildConfigService: BuildConfigService,
    private readonly route: ActivatedRoute,
    public analyticsService: AnalyticsService,
    private readonly liveChatService: LiveChatService
  ) {
    super();
  }

  /**
   * Pickup error message from url
   */
  ngOnInit() {
    this.getMessage();
    this.getCurrentPlan();
  }

  /**
   * Pickup error message from url
   */
  getMessage() {
    this.route.queryParams
      .pipe(takeUntil(this.destroy$), take(1))
      .subscribe(({ msg }) => (this.msg = msg));
  }

  /**
   * Retrive currentPlan
   */
  getCurrentPlan() {
    this.viewOffersService.currentPlan$
      .pipe(takeUntil(this.destroy$))
      .subscribe((currentPlan) => {
        this.currentPlan = currentPlan;
        this.analyticsService.eventEmitter(
          new GACSPageLoad(this.currentPlan).gaData
        );
      });
  }

  /**
   * Navigate to contact us on click
   */
  onClick() {
    window.open(this.links.contact_us);
  }

  openLiveChat(): void {
    this.liveChatService.openLiveChat();
  }
}
